import { Button } from '@/components/ui/button';
import { Loader, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ErrorMessage from '../../error-message/ErrorMessage';
import { EquipmentAvailabilityModal } from '../../modals/equipment-availability-modal/EquipmentAvailabilityModal';
import TableColumnsToggle from '../../table-columns-toggle/TableColumnsToggle';
import { GenericTable } from '../common/generic-table/GenericTable';
import TableSearchInput from '../common/table-search-input/TableSearchInput';
import useInventoryTable from '@/hooks/table/useInventoryTable';
import { useNavigate } from 'react-router-dom';

export function InventoryTable() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    table,
    equipmentData,
    emptyData,
    search,
    onSearch,
    featureFlagCrudValue,
    isError,
    isFetching,
    isLoading,
    openModal,
    setOpenModal
  } = useInventoryTable();

  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <>
      <div
        className={`flex items-center gap-2 py-4 ${featureFlagCrudValue ? 'justify-between' : 'justify-end'}`}
      >
        {featureFlagCrudValue && (
          <Button
            onClick={() => navigate('./create')}
            className="flex items-center gap-2"
          >
            <PlusIcon className="w-5" />
            <p>{t('form.create')}</p>
          </Button>
        )}
        <div className="flex flex-col-reverse items-start justify-center gap-2 md:flex-row">
          <div className="flex items-center w-full gap-3">
            <TableSearchInput value={search ?? ''} onChange={onSearch} />
            {search && isFetching && (
              <Loader className="text-gray-600 animate-spin" />
            )}
          </div>
          <TableColumnsToggle disabled={emptyData} table={table} />
        </div>
      </div>
      <GenericTable table={table} isLoading={isLoading} />
      {openModal && equipmentData ? (
        <EquipmentAvailabilityModal
          open={openModal}
          onOpenChange={setOpenModal}
          equipmentData={equipmentData}
        />
      ) : null}
    </>
  );
}
